/**
 * EventosAgrupados — renderiza os eventos de UM dia agrupados por cliente
 * (F11): o nome do cliente aparece uma vez e os ambientes ficam em
 * sub-lista. Usado nas visões de Mês, Semana e no popover do dia.
 *
 * Props:
 *  - eventos: eventos daquele dia (cada um com groupLabel = cliente,
 *    title = ambiente, tone, subtitle, payload, previsao?)
 *  - onSelectEvent(ev)
 *  - $outside: dia fora do mês (opacidade reduzida)
 *  - maxAmbientes?: limita o total de ambientes exibidos (células do Mês);
 *    quando estoura, mostra "+N mais" que chama onMais()
 *  - onMais?(): callback do "+N mais"
 */
import React from "react";

import {
  agruparEventosPorCliente,
  limitarGruposPorAmbientes,
} from "./calendarGrid";
import {
  AmbienteItem,
  GrupoCliente,
  GrupoClienteCont,
  GrupoClienteNome,
  MoreLink,
} from "./styles";

export default function EventosAgrupados({
  eventos,
  onSelectEvent,
  $outside,
  maxAmbientes,
  onMais,
}) {
  const todos = agruparEventosPorCliente(eventos);
  const { gruposVisiveis, ocultos } = maxAmbientes
    ? limitarGruposPorAmbientes(todos, maxAmbientes)
    : { gruposVisiveis: todos, ocultos: 0 };

  return (
    <>
      {gruposVisiveis.map((grupo) => (
        <GrupoCliente key={grupo.chave}>
          {grupo.label != null && (
            <GrupoClienteNome $outside={$outside} title={grupo.label}>
              <span>{grupo.label}</span>
              {grupo.eventos.length > 1 && (
                <GrupoClienteCont>{grupo.eventos.length}</GrupoClienteCont>
              )}
            </GrupoClienteNome>
          )}
          {grupo.eventos.map((ev) => (
            <AmbienteItem
              type="button"
              key={ev.id}
              $tone={ev.tone}
              $previsao={Boolean(ev.previsao)}
              $outside={$outside}
              title={ev.subtitle ? `${ev.title} · ${ev.subtitle}` : ev.title}
              onClick={(domEvent) => {
                domEvent.stopPropagation();
                onSelectEvent?.(ev);
              }}
            >
              {ev.title}
            </AmbienteItem>
          ))}
        </GrupoCliente>
      ))}
      {ocultos > 0 && (
        <MoreLink
          type="button"
          onClick={(domEvent) => {
            domEvent.stopPropagation();
            onMais?.();
          }}
        >
          +{ocultos} mais
        </MoreLink>
      )}
    </>
  );
}
